<script setup lang="ts">
definePageMeta({
  layout: 'search',
})

useSetSEO()
</script>

<template>
  <NovaSearchResultDetailUser />
</template>

<style scoped lang="scss"></style>
